import { Component, OnInit } from '@angular/core';
import {User} from "../../../shared/interface/user";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-edit-dialog-competition-import-row',
  templateUrl: './edit-dialog-competition-import-row.component.html',
  styleUrls: ['./edit-dialog-competition-import-row.component.scss']
})
export class EditDialogCompetitionImportRowComponent implements OnInit {
  userObject?: User = null;

  constructor(
    public dialogRef: MatDialogRef<EditDialogCompetitionImportRowComponent>,
  ) { }

  ngOnInit(): void {
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
